<template>
  <div class="student-manage">
    <div class="header">
      <el-input
        v-model="keyword"
        placeholder="搜索学生姓名、学号、班级或学校"
        style="width: 300px"
        @keyup.enter.native="search"
      >
        <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
      </el-input>
      <el-button type="primary" @click="showAddDialog">新增学生</el-button>
    </div>

    <el-table :data="studentList" style="width: 100%; margin-top: 20px">
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="studentNo" label="学号" />
      <el-table-column prop="studentName" label="姓名" />
      <el-table-column prop="gender" label="性别" width="80" />
      <el-table-column prop="phone" label="电话" />
      <el-table-column prop="className" label="班级" />
      <el-table-column prop="collegeName" label="学校" />
      <el-table-column prop="majorName" label="专业" />
      <el-table-column prop="grade" label="年级" width="100" />
      <el-table-column label="操作" width="180" fixed="right">
        <template slot-scope="scope">
          <el-button size="small" @click="showEditDialog(scope.row)">编辑</el-button>
          <el-button size="small" type="danger" @click="handleDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :total="total"
      layout="total, prev, pager, next"
      @current-change="loadStudentList"
      style="margin-top: 20px; text-align: center"
    />

    <el-dialog :visible.sync="dialogVisible" :title="dialogTitle" width="600px">
      <el-form :model="formData" label-width="100px">
        <el-form-item label="学号">
          <el-input v-model="formData.studentNo" />
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="formData.studentName" />
        </el-form-item>
        <el-form-item label="性别">
          <el-radio-group v-model="formData.gender">
            <el-radio label="男">男</el-radio>
            <el-radio label="女">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="电话">
          <el-input v-model="formData.phone" />
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="formData.email" />
        </el-form-item>
        <el-form-item label="所属学校">
          <el-select v-model="formData.collegeId" placeholder="请选择学校" @change="onCollegeChange">
            <el-option
              v-for="college in collegeList"
              :key="college.id"
              :label="college.collegeName"
              :value="college.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="所属专业">
          <el-select v-model="formData.majorId" placeholder="请选择专业" @change="onMajorChange">
            <el-option
              v-for="major in majorList"
              :key="major.id"
              :label="major.majorName"
              :value="major.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="所属班级">
          <el-select v-model="formData.classId" placeholder="请选择班级" @change="onClassChange">
            <el-option
              v-for="classItem in classList"
              :key="classItem.id"
              :label="classItem.className"
              :value="classItem.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="年级">
          <el-input-number v-model="formData.grade" :min="2000" :max="2100" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import studentApi from '@/api/student'
import collegeApi from '@/api/college'
import majorApi from '@/api/major'
import classApi from '@/api/class'

export default {
  name: 'StudentManage',
  data() {
    return {
      keyword: '',
      studentList: [],
      collegeList: [],
      majorList: [],
      classList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      dialogTitle: '',
      isEdit: false,
      formData: {
        id: null,
        studentNo: '',
        studentName: '',
        gender: '男',
        phone: '',
        email: '',
        classId: null,
        className: '',
        collegeId: null,
        collegeName: '',
        majorId: null,
        majorName: '',
        grade: new Date().getFullYear()
      }
    }
  },
  mounted() {
    this.loadStudentList()
    this.loadCollegeList()
  },
  methods: {
    async loadStudentList() {
      try {
        const res = await studentApi.getStudentList(this.currentPage, this.pageSize, this.keyword)
        this.studentList = res.data.data
        this.total = res.data.total
      } catch (error) {
        this.$message.error('加载学生列表失败')
      }
    },
    async loadCollegeList() {
      try {
        const res = await collegeApi.getCollegeList(1, 1000, '')
        this.collegeList = res.data.data
      } catch (error) {
        this.$message.error('加载学校列表失败')
      }
    },
    async loadMajorList(collegeId) {
      try {
        const res = await majorApi.getMajorList(1, 1000, '', collegeId)
        this.majorList = res.data.data
      } catch (error) {
        this.$message.error('加载专业列表失败')
      }
    },
    async loadClassList(majorId) {
      try {
        const res = await classApi.getClassList(1, 1000, '')
        this.classList = res.data.data.filter(c => c.majorId === majorId)
      } catch (error) {
        this.$message.error('加载班级列表失败')
      }
    },
    search() {
      this.currentPage = 1
      this.loadStudentList()
    },
    showAddDialog() {
      this.dialogTitle = '新增学生'
      this.isEdit = false
      this.formData = {
        id: null,
        studentNo: '',
        studentName: '',
        gender: '男',
        phone: '',
        email: '',
        classId: null,
        className: '',
        collegeId: null,
        collegeName: '',
        majorId: null,
        majorName: '',
        grade: new Date().getFullYear()
      }
      this.majorList = []
      this.classList = []
      this.dialogVisible = true
    },
    async showEditDialog(row) {
      this.dialogTitle = '编辑学生'
      this.isEdit = true
      this.formData = { ...row }
      if (row.collegeId) {
        await this.loadMajorList(row.collegeId)
      }
      if (row.majorId) {
        await this.loadClassList(row.majorId)
      }
      this.dialogVisible = true
    },
    onCollegeChange(collegeId) {
      const college = this.collegeList.find(c => c.id === collegeId)
      if (college) {
        this.formData.collegeName = college.collegeName
        this.loadMajorList(collegeId)
        this.formData.majorId = null
        this.formData.majorName = ''
        this.formData.classId = null
        this.formData.className = ''
        this.classList = []
      }
    },
    onMajorChange(majorId) {
      const major = this.majorList.find(m => m.id === majorId)
      if (major) {
        this.formData.majorName = major.majorName
        this.loadClassList(majorId)
        this.formData.classId = null
        this.formData.className = ''
      }
    },
    onClassChange(classId) {
      const classItem = this.classList.find(c => c.id === classId)
      if (classItem) {
        this.formData.className = classItem.className
      }
    },
    async handleSubmit() {
      try {
        if (this.isEdit) {
          await studentApi.updateStudent(this.formData)
          this.$message.success('更新成功')
        } else {
          await studentApi.addStudent(this.formData)
          this.$message.success('添加成功')
        }
        this.dialogVisible = false
        this.loadStudentList()
      } catch (error) {
        this.$message.error(this.isEdit ? '更新失败' : '添加失败')
      }
    },
    handleDelete(id) {
      this.$confirm('确定要删除这个学生吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await studentApi.deleteStudent(id)
          this.$message.success('删除成功')
          this.loadStudentList()
        } catch (error) {
          this.$message.error('删除失败')
        }
      })
    }
  }
}
</script>

<style scoped>
.student-manage {
  padding: 20px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
